'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rj = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _lodash = require('lodash.pick');

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = require('./utils');

var _actions = require('./actions');

var _reducer = require('./reducer');

var _selectors = require('./selectors');

var _helpers = require('./helpers');

var _sideEffectDescriptor = require('./sideEffectDescriptor');

var _lodash3 = require('lodash.omit');

var _lodash4 = _interopRequireDefault(_lodash3);

var _apiSaga = require('./apiSaga');

var _apiSaga2 = _interopRequireDefault(_apiSaga);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var rocketjump = function rocketjump() {
  for (var _len = arguments.length, configs = Array(_len), _key = 0; _key < _len; _key++) {
    configs[_key] = arguments[_key];
  }

  var jumpConfig = configs.reduce(function (merged, config) {
    if (typeof config === 'function') {
      return merged;
    }

    return _extends({}, merged, config);
  }, {});

  var jumper = function jumper() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var extendExport = arguments[1];
    var allConfigs = [].concat(configs, [config]);

    var mergedConfig = _extends({}, jumpConfig, config);

    (0, _invariant2.default)(mergedConfig.type, 'You must specify a type key for actions and reducer');
    (0, _invariant2.default)(typeof mergedConfig.state !== 'undefined', 'You must specify a state key for create selectors' + ', if you want to omit the state creation set state explice to false.');
    var finalExport = allConfigs.reduce(function (finalExport, config, i) {
      // When config is a function is intendeed to be a rocketjump!
      if (typeof config === 'function') {
        return config((0, _lodash4.default)(mergedConfig, ['api', 'callApi', 'apiExtraParams', 'successEffect', 'failureEffect', 'needEffect', 'proxySelectors', 'proxyActions', 'proxyReducer', 'composeReducer', 'mapLoadingAction', 'mapSuccessAction', 'mapFailureAction', 'unloadBy']), finalExport);
      }

      var exp = typeof finalExport === 'undefined' ? // Make the export for the first time
      {
        sideEffect: (0, _sideEffectDescriptor.makeSideEffectDescriptor)(),
        actions: (0, _actions.makeActions)(mergedConfig.type),
        reducer: mergedConfig.state === false ? undefined : (0, _reducer.makeReducer)(mergedConfig.type, mergedConfig.dataReducer),
        selectors: mergedConfig.state === false ? undefined : (0, _selectors.makeSelectors)(mergedConfig.state)
      } : // Continued to previous export
      _extends({}, finalExport);
      exp.sideEffect = (0, _sideEffectDescriptor.addConfigToSideEffectDescritor)(exp.sideEffect, config);
      exp.actions = (0, _utils.proxyObject)(exp.actions, config.proxyActions);
      exp.reducer = typeof exp.reducer === 'undefined' ? undefined : (0, _utils.proxyReducer)(exp.reducer, config.proxyReducer);
      exp.reducer = typeof exp.reducer === 'undefined' ? undefined : Array.isArray(config.composeReducer) ? _helpers.composeReducers.apply(undefined, _toConsumableArray([exp.reducer].concat(config.composeReducer))) : exp.reducer;
      exp.selectors = typeof exp.selectors === 'undefined' ? undefined : (0, _utils.proxyObject)(exp.selectors, config.proxySelectors);
      return exp;
    }, extendExport);

    if (typeof mergedConfig.saga === 'function') {
      // Custom saga...
      var saga = mergedConfig.saga((0, _lodash2.default)(mergedConfig, ['type', 'state', 'api', 'apiExtraParams', 'takeEffect', 'callApi', 'successEffect', 'failureEffect', 'takeEffectArgs']));
      return _extends({}, (0, _lodash4.default)(finalExport, 'sideEffect'), {
        saga: saga
      });
    } else if (typeof mergedConfig.api === 'function') {
      // Time 2 make real saga!
      var sideEffect = finalExport.sideEffect;

      var _saga = (0, _apiSaga2.default)(mergedConfig.type, mergedConfig.api, sideEffect.apiExtraParams, sideEffect.takeEffect, sideEffect.callApi, sideEffect.needEffect, sideEffect.successEffect, sideEffect.failureEffect, sideEffect.takeEffectArgs, sideEffect.mapLoadingAction, sideEffect.mapSuccessAction, sideEffect.mapFailureAction, sideEffect.unloadBy);

      return _extends({}, (0, _lodash4.default)(finalExport, 'sideEffect'), {
        reducer: sideEffect.unloadBy.length > 0 ? (0, _helpers.resetReducerOn)(sideEffect.unloadBy, finalExport.reducer) : finalExport.reducer,
        saga: _saga
      });
    } else {
      // Pass down side effect descriptor
      return finalExport;
    }
  }; // Attach current rj config to returned fn
  // ... is only js ...


  jumper.config = jumpConfig;
  return jumper;
};

exports.rj = rocketjump;